import React from 'react';
import { Link } from 'react-router-dom';
import styles from './OpenHoursSection.module.css';

const HOURS = [
    { label: 'Tuesday — Sunday', time: '1:00 PM — 1:30 AM' },
    { label: 'Monday (Dinner only)', time: '6:00 PM — 1:30 AM' },
];

const TERMS = [
    'Last food order: 12:45 AM',
    'Last alcohol order: 1:00 AM',
    'Last table booking: 1:00 AM',
    'Restaurant closes: 1:30 AM'
];

const OpenHoursSection = () => {
    // Reduced to 4 images for a cleaner, compact 2x2 gallery layout
    const img1 = '/images/27-DSC09435.jpg';
    const img2 = '/images/19-DSC09397.jpg';
    const img3 = '/images/22-DSC09424.jpg';
    const img4 = '/images/1-DSC09321.jpg';

    return (
        <section className={styles.sectionContainer}>
            <div className={styles.wrapper}>

                {/* ── Left Side: Compact Image Gallery ── */}
                <div className={styles.imageGallery}>
                    <div className={styles.imageCard}>
                        <img src={img1} alt="Berli Brewing interior" />
                    </div>
                    <div className={styles.imageCard}>
                        <img src={img2} alt="Brewer at work" />
                    </div>
                    <div className={styles.imageCard}>
                        <img src={img3} alt="Berli food plating" />
                    </div>
                    <div className={styles.imageCard}>
                        <img src={img4} alt="Craft beer pour" />
                    </div>
                </div>

                {/* ── Right Side: Content Block ── */}
                <div className={styles.contentBlock}>
                    <h2 className={styles.heading}>Opening Hours</h2>

                    <div className={styles.hoursList}>
                        {HOURS.map(({ label, time }) => (
                            <p key={label} className={styles.hoursLine}>
                                <span className={styles.label}>{label}</span>
                                <span className={styles.time}>{time}</span>
                            </p>
                        ))}
                    </div>

                    <div className={styles.buttonGroup}>
                        <Link to="/menu" className={styles.menuBtn}>
                            View Menu
                        </Link>
                        <Link to="/reservation" className={styles.bookLink}>
                            Book a Table
                        </Link>
                    </div>

                    {/* Terms & Conditions Section */}
                    <div className={styles.termsBox}>
                        <h3 className={styles.termsHeading}>Important Details</h3>
                        <ul className={styles.termsList}>
                            {TERMS.map((term, index) => (
                                <li key={index}>{term}</li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default OpenHoursSection;